class Storage {
    constructor(prefix = 'apropos-jobs__') {
        this.prefix = prefix
    }

    set(key, value) {
        try {
            const storageKey = this.prefix + key
            const serializedValue = JSON.stringify(value)

            if (typeof serializedValue === 'undefined') {
                window.localStorage.removeItem(storageKey)
                return true
            }

            window.localStorage.setItem(storageKey, serializedValue)
            return true
        } catch (err) {
            return false
        }
    }

    get(key, fallback = null) {
        const storageKey = this.prefix + key
        let item

        try {
            item = window.localStorage.getItem(storageKey)
        } catch (err) {
            return fallback
        }

        if (item === null) {
            return fallback
        }

        try {
            return JSON.parse(item)
        } catch (err) {
            try {
                window.localStorage.removeItem(storageKey)
            } catch (removeError) {
                // Storage access failures must not prevent application startup.
            }

            return fallback
        }
    }

    remove(key) {
        try {
            window.localStorage.removeItem(this.prefix + key)
            return true
        } catch (err) {
            return false
        }
    }

    flush() {
        window.localStorage.clear()
    }
}

export default new Storage
